import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Store } from '@ngrx/store';
import {
  updatecurrentUrl,
  updateHeaderText,
} from '../../../+state/app-settings.actions';
import { APP_NAME } from '../../constants/app.constants';
import { RootState } from '../../interfaces/rootState.interface';

@Injectable({ providedIn: 'root' })
export class HeaderRouteResolver implements Resolve<void> {
  private store: Store<RootState> = inject(Store);
  private titleService = inject(Title);

  resolve(route: ActivatedRouteSnapshot): void {
    const headerText = route.data.headerTitle;

    // Always keep the browser tab title accurate so a previous route's title
    // (e.g. a report name) can't stick. Routes without an in-app header just
    // show the app name. (EDUS-2332)
    this.titleService.setTitle(
      headerText ? `${headerText} - ${APP_NAME}` : APP_NAME
    );

    // Routes without a header title have no in-app header — don't touch header
    // state or the current-URL tracker for them.
    if (!headerText) {
      return;
    }

    const currentUrl = route.url.join('/');

    this.store.dispatch(
      updateHeaderText({
        headerText: headerText,
      })
    );

    this.store.dispatch(updatecurrentUrl({ currentUrl: currentUrl }));
  }
}
